const AuthSubUserService = {

  login(token) {
    return new Promise((resolve, reject) => {
      axios.post('auth/subuser/login', token)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  logout() {
    return new Promise((resolve, reject) => {
      axios.post('auth/subuser/logout')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  refresh() {
    return new Promise((resolve, reject) => {
      axios.post('auth/subuser/refresh')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  me() {
    return new Promise((resolve, reject) => {
      axios.get('auth/subuser/me')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default AuthSubUserService;
